import Unsplash from "unsplash-js";
import getConfig from "../utils/config";
import { UNSPLASH } from "../common/constants";

const unsplash = new Unsplash(getConfig(UNSPLASH));

export default function search({ keyword, page = 1, pageSize = 10 }) {
  return unsplash.search.photos(keyword, page, pageSize).then(res => res.json());
}
